<template>
    <div class="electrical-warning-warp">
        <monitorTitle nub="5" text="电器部件预警" width="auto" />

        <div class="box">
            <dv-capsule-chart :config="config" style="width:360px;height:200px;" v-if="show" />
        </div>
    </div>
</template>

<script>
  import {
    UserStore
  } from '@/utils/Mixin'
  export default {
    mixins: [UserStore],
    watch: {
      Data (n) {
        this.getData()
      }
    },
    data () {
      return {
        show: false,
        config: {
          data: [{
                   name: '触摸按键',
                   value: 0
                 },
                 {
                   name: '加热管',
                   value: 0
                 },
                 {
                   name: '高压开关',
                   value: 0
                 },
                 {
                   name: '进水电磁阀',
                   value: 0
                 },
                 {
                   name: '放水电磁阀',
                   value: 0
                 },
                 {
                   name: '设备数',
                   value: 0
                 }
          ],
          unit: '次',
          colors: ['#17f0fc', '#17fcd9', '#17fcb8', '#3eff7e', '#ffe065', '#ff9f7f']
        }
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        this.show = false

        let _data = {
          num1: 0,
          num2: 0,
          num3: 0,
          num4: 0,
          num5: 0,
          num6: 0
        }
        if (this.Data && this.Data.data5) {
          _data = Object.assign(_data, this.Data.data5)
        }

        let data = []

        let config = JSON.parse(JSON.stringify(this.config))

        config.data.forEach((i, k) => {
          let value = _data.hasOwnProperty(`num${k + 1}`) ? parseInt(_data[`num${k + 1}`]) : 0
          data.push({
            ...i,
            value
          })
        })
        this.config = Object.assign(config, {
          data
        })
        this.show = true
      }
    }
  }
</script>

<style lang="less" scoped>
    .electrical-warning-warp {
        width: 387px;
        .box {
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            height: 238px;
            background-image: url("/static/images/home/chart-bg.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
</style>
